import { useEffect, useState } from 'react';

export const useCurrentURL = (): URL => {
  const [currentURL, setCurrentURL] = useState(
    () => new URL(window.location.href)
  );

  useEffect(() => {
    const updateURL = () => setCurrentURL(new URL(window.location.href));

    window.addEventListener('popstate', updateURL);
    window.addEventListener('hashchange', updateURL);

    updateURL();

    return () => {
      window.removeEventListener('popstate', updateURL);
      window.removeEventListener('hashchange', updateURL);
    };
  }, []);

  return currentURL;
};
